// src/components_admin/AdminSidebarLayout.tsx
import { Provider } from 'react-redux';
import { store } from '../store/store';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
} from '../components_catalyst/sidebar';
import { SidebarLayout } from '../components_catalyst/sidebar-layout';
import { useAuth } from '../components_auth/AuthContext';
import {
  UsersIcon,
  MapIcon,
  BuildingOfficeIcon,
  DocumentCheckIcon,
  DocumentArrowUpIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import { clsx } from 'clsx';
import { EnvironmentReminder } from '../utils/EnvironmentReminder';

export function AdminSidebarLayout() {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }

  return (
    <>
      <SidebarLayout
        navbar={<div className="h-14 bg-pink-950   text-white" />}
        sidebar={
          <Sidebar className="bg-pink-950 text-white">
            <SidebarHeader>
              <SidebarItem>
                <SidebarLabel className="text-white font-bold">Admin Dashboard</SidebarLabel>
              </SidebarItem>
            </SidebarHeader>

            <SidebarBody>
              <SidebarSection>
                {[
                  { href: '/admin/user-profiles', label: 'User Profiles', icon: UsersIcon },
                  { href: '/admin/milestone-maps', label: 'Milestone Maps', icon: MapIcon },
                  { href: '/admin/objectives', label: 'Objectives', icon: DocumentCheckIcon },
                  { href: '/admin/orgs', label: 'Organizations', icon: BuildingOfficeIcon },
                  { href: '/admin/signup-links', label: 'Signup Links', icon: SparklesIcon },
                  { href: '/admin/backup', label: 'Backup', icon: DocumentArrowUpIcon },
                ].map(({ href, label, icon: Icon }) => {
                  const isActive = location.pathname === href;
                  return (
                    <SidebarItem
                      key={href}
                      href={href}
                      current={isActive}
                      className={clsx('text-white hover:bg-pink-800', isActive && 'bg-pink-800')}
                    >
                      <Icon className="h-6 w-6 text-white" />
                      <SidebarLabel className="text-white">{label}</SidebarLabel>
                    </SidebarItem>
                  );
                })}
              </SidebarSection>
            </SidebarBody>
          </Sidebar>
        }
      >
        <EnvironmentReminder />
        <div className="min-h-screen border-2 border-pink-800">
          <Outlet />
        </div>
      </SidebarLayout>
    </>
  );
}
